<ng-container *transloco="let t">
  <form #borrowerInfoForm="ngForm" novalidate id="borrowerInfoForm" name="borrowerInfoForm">
      @if (!isHidden('borrower.firstName')) {
        <div class="row mb-6">
          <label class="col-lg-4 col-form-label fw-bold fs-6">
            <span [ngClass]="{'required': isRequired('borrower.firstName')}">{{ getLabel('borrower.firstName', t('wizard.borrowerInfo.firstName')) }}</span>
          </label>
          <div class="col-lg-8 fv-row">
            <input type="text" id="firstName" name="firstName" #firstName="ngModel" [required]="isRequired('borrower.firstName')"
              [ngClass]="{'is-invalid' : firstName && firstName.touched && firstName.invalid}"
              [(ngModel)]="borrower.firstName" class="form-control form-control-lg form-control-solid"
              [placeholder]="getLabel('borrower.firstName', t('wizard.borrowerInfo.firstName'))" />
            <div class="invalid-feedback">{{ t('wizard.borrowerInfo.pleaseEnterFirstName') }}</div>
          </div>
        </div>
      }
      @if (!isHidden('borrower.lastName')) {
        <div class="row mb-6">
          <label class="col-lg-4 col-form-label fw-bold fs-6">
            <span [ngClass]="{'required': isRequired('borrower.lastName')}">{{ getLabel('borrower.lastName', t('wizard.borrowerInfo.lastName')) }}</span>
          </label>
          <div class="col-lg-8 fv-row">
            <input type="text" id="lastName" name="lastName" #lastName="ngModel" [required]="isRequired('borrower.lastName')"
              [ngClass]="{'is-invalid' : lastName && lastName.touched && lastName.invalid}"
              [(ngModel)]="borrower.lastName" class="form-control form-control-lg form-control-solid"
              [placeholder]="getLabel('borrower.lastName', t('wizard.borrowerInfo.lastName'))" />
            <div class="invalid-feedback">{{ t('wizard.borrowerInfo.pleaseEnterLastName') }}</div>
          </div>
        </div>
      }
      @if (!isHidden('borrower.mobilePhone')) {
        <div class="row mb-6">
          <label class="col-lg-4 col-form-label fw-bold fs-6">
            <span [ngClass]="{'required': phoneRequired()}">{{ getLabel('borrower.mobilePhone', t('wizard.borrowerInfo.phoneNumber')) }}</span>
          </label>
          <div class="col-lg-8">
            <div class="row g-3">
              @if (showPhoneType) {
                <div class="col-sm-4 fv-row">
                  <select class="form-select form-select-lg form-select-solid" id="phoneType" name="phoneType" #phoneTypeModel="ngModel"
                    [(ngModel)]="phoneType" (ngModelChange)="onPhoneTypeChanged()" [required]="phoneTypeRequired()"
                    [attr.aria-label]="getLabel('borrower.phoneType', t('wizard.borrowerInfo.phoneType'))"
                    [ngClass]="{'is-invalid' : phoneTypeModel && phoneTypeModel.touched && phoneTypeModel.invalid}">
                    @for (type of phoneTypes; track type) {
                      <option [ngValue]="type">{{ t('wizard.borrowerInfo.phoneType' + type) }}</option>
                    }
                  </select>
                </div>
              }
              <div class="fv-row" [ngClass]="showPhoneType ? 'col-sm-8' : 'col-sm-12'">
                <input type="text" id="mobilePhone" name="mobilePhone" mask='(000) 000-0000' #mobilePhone="ngModel"
                  [ngClass]="{'is-invalid' : mobilePhone && mobilePhone.touched && mobilePhone.invalid}"
                  [ngModel]="enteredPhone" (ngModelChange)="onBorrowerPhoneChanged($event)" [required]="phoneRequired()"
                  class="form-control form-control-lg form-control-solid"
                  [placeholder]="getLabel('borrower.mobilePhone', t('wizard.borrowerInfo.phoneNumber'))" />
                <div class="invalid-feedback">{{ t('wizard.borrowerInfo.pleaseEnterValidPhone') }}</div>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="row mb-6">
        <label class="col-lg-4 col-form-label fw-bold fs-6">
          <span class="required">{{ t('wizard.borrowerInfo.emailAddress') }}</span>
          <div class="fs-7 fw-bold text-muted">{{ t('wizard.borrowerInfo.willBeUsedAsUserId') }}</div>
        </label>
        <div class="col-lg-8 fv-row">
          <input type="email" id="emailAddress" [email]="true" trim name="emailAddress" #email="ngModel" required [ngClass]="{'is-invalid' : email && email.touched && email.invalid}"
            [(ngModel)]="borrower.primaryEmail" class="form-control form-control-lg form-control-solid" [placeholder]="t('wizard.borrowerInfo.emailAddress')" />
          <div class="invalid-feedback">{{ t('wizard.borrowerInfo.pleaseEnterValidEmail') }}</div>
        </div>
      </div>
      @if (doesSetPassword) {
        <div class="row mb-6 position-relative">
          <label class="col-lg-4 col-form-label fw-bold fs-6">
            <span class="required">{{ t('wizard.borrowerInfo.password') }}</span>
          </label>
          <div class="col-lg-8 fv-row">
            <input type="password" class="form-control form-control-solid has-visibility-toggle" [(ngModel)]="password" autocomplete="off"
                  placeholder="" name="password" id="password"
                  required
                  [minlength]="passwordPolicy?.minimumPasswordLength || 8"
                  (mousedown)="op.show($event)"
                  (ngModelChange)="onPasswordChanged()"
                  (blur)="op.hide()"
                  [ngClass]="{'is-invalid' : userPassword && userPassword.touched && userPassword.invalid}" #userPassword="ngModel"
                  validateEqual="confirmedPassword"  reverse="true" />
                  <p-popover #op styleClass="password-validation-overlay">
                    <ng-template pTemplate="content">
                      <div>
                        <div class="d-flex password-validation-indicator" [ngClass]="{
                            'text-success': passwordIsMinimum8Characters
                            }">
                          <i class="far password-validation-indicator-icon fa-sad-tear" [ngClass]="{
                              'fa-smile': passwordIsMinimum8Characters,
                              'text-success': passwordIsMinimum8Characters
                              }"></i>
                          <div>{{ t('auth.resetPassword.minChars') }}</div>
                        </div>
                        @if (!passwordPolicy || passwordPolicy.requireDigit) {
                        <div class="d-flex password-validation-indicator" [ngClass]="{
                            'text-success': passwordContainsDigit
                            }">
                          <i class="far password-validation-indicator-icon fa-sad-tear" [ngClass]="{
                              'fa-smile': passwordContainsDigit,
                              'text-success': passwordContainsDigit
                              }"></i>
                          <div>{{ t('auth.resetPassword.includeNumber') }}</div>
                        </div>
                        }
                        @if (!passwordPolicy || passwordPolicy.requireLowercase) {
                        <div class="d-flex password-validation-indicator" [ngClass]="{
                          'text-success': passwordContainsLowercase
                          }">
                          <i class="far password-validation-indicator-icon fa-sad-tear" [ngClass]="{
                            'fa-smile': passwordContainsLowercase,
                            'text-success': passwordContainsLowercase
                            }"></i>
                          <div>{{ t('auth.resetPassword.includeLowercase') }}</div>
                        </div>
                        }
                        @if (!passwordPolicy || passwordPolicy.requireUppercase) {
                        <div class="d-flex password-validation-indicator" [ngClass]="{
                        'text-success': passwordContainsUppercase
                        }">
                          <i class="far password-validation-indicator-icon fa-sad-tear" [ngClass]="{
                          'fa-smile': passwordContainsUppercase,
                          'text-success': passwordContainsUppercase
                          }"></i>
                          <div>{{ t('auth.resetPassword.includeUppercase') }}</div>
                        </div>
                        }
                        @if (!passwordPolicy || passwordPolicy.requireSpecialCharacter) {
                        <div class="d-flex password-validation-indicator" [ngClass]="{
                          'text-success': passwordContainsSpecialCharacter
                          }">
                            <i class="far password-validation-indicator-icon fa-sad-tear" [ngClass]="{
                            'fa-smile': passwordContainsSpecialCharacter,
                            'text-success': passwordContainsSpecialCharacter
                            }"></i>
                            <div>{{ t('auth.resetPassword.includeSpecial') }}</div>
                          </div>
                        }
                      </div>

                    </ng-template>
                  </p-popover>
            @if (userPassword.errors && userPassword.errors.required) {
              <div class="invalid-feedback">{{ t('wizard.borrowerInfo.pleaseEnterPassword') }}</div>
            }
            @if (userPassword.errors && !userPassword.errors.required) {
              <div class="invalid-feedback">{{ t('wizard.borrowerInfo.passwordDoesNotMeetRequirements') }}</div>
            }
            @if (userPassword.errors && userPassword.errors.validateEqual) {
              <div class="invalid-feedback">{{ t('wizard.borrowerInfo.passwordsDoNotMatch') }}</div>
            }
            <span class="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2"
                  data-kt-password-meter-control="visibility">
              @if (!passwordInputState.displayed) {
                <i class="bi bi-eye-slash fs-2" [ngClass]="{'mb-7': userPassword.touched && userPassword.errors && userPassword.errors?.required}"
                  (click)="onPasswordStateClicked(passwordInputState)" (touchend)="onPasswordStateClicked(passwordInputState)"></i>
              }
              @if (passwordInputState.displayed) {
                <i class="bi bi-eye fs-2" [ngClass]="{'mb-7': userPassword.touched && userPassword.errors && userPassword.errors?.required}"
                  (click)="onPasswordStateClicked(passwordInputState)" (touchend)="onPasswordStateClicked(passwordInputState)"></i>
              }
            </span>
          </div>
        </div>
        <div class="row mb-6 position-relative">
          <label class="col-lg-4 col-form-label fw-bold fs-6">
            <span class="required">{{ t('wizard.borrowerInfo.confirmPassword') }}</span>
          </label>
          <div class="col-lg-8 fv-row">
          <input type="password" class="form-control form-control-solid has-visibility-toggle" [(ngModel)]="confirmedPassword" autocomplete="off" required
                  placeholder="" name="confirmedPassword" id="confirmedPassword"
                  [ngClass]="{'is-invalid' : userConfirmedPassword && userConfirmedPassword.touched && userConfirmedPassword.invalid}" #userConfirmedPassword="ngModel"
                  validateEqual="password" />
          @if (userConfirmedPassword.errors && userConfirmedPassword.errors.required) {
            <div class="invalid-feedback">{{ t('wizard.borrowerInfo.pleaseEnterPasswordAgain') }}</div>
          }
          @if (userConfirmedPassword.errors && userConfirmedPassword.errors.validateEqual) {
            <div class="invalid-feedback">{{ t('wizard.borrowerInfo.passwordsDoNotMatch') }}</div>
          }
          <span class="btn btn-sm btn-icon position-absolute translate-middle top-50 end-0 me-n2"
          data-kt-password-meter-control="visibility">
          @if (!confirmPasswordInputState.displayed) {
            <i class="bi bi-eye-slash fs-2"
              [ngClass]="{'mb-7': userConfirmedPassword.touched && userConfirmedPassword.errors && (userConfirmedPassword.errors?.validateEqual || !confirmedPassword),
              'mb-14': password && userConfirmedPassword.touched && userConfirmedPassword.errors && userConfirmedPassword.errors.required}"
              (click)="onPasswordStateClicked(confirmPasswordInputState)" (touchend)="onPasswordStateClicked(confirmPasswordInputState)"></i>
          }
          @if (confirmPasswordInputState.displayed) {
            <i class="bi bi-eye fs-2"
              [ngClass]="{'mb-7': userConfirmedPassword.touched && userConfirmedPassword.errors && (userConfirmedPassword.errors?.validateEqual || !confirmedPassword),
              'mb-14': password && userConfirmedPassword.touched && userConfirmedPassword.errors &&
              userConfirmedPassword.errors?.required}"
              (click)="onPasswordStateClicked(confirmPasswordInputState)" (touchend)="onPasswordStateClicked(confirmPasswordInputState)"></i>
          }
        </span>
          </div>
        </div>
      }
  </form>
</ng-container>
